import styled from "styled-components"
import { TextButton } from "../Text"
import { BsPersonCircle } from "react-icons/bs"
import { useRecoilValue } from "recoil"
import { isLoggedInState } from "../../../recoil/auth/atom"
import { useNavigate } from "react-router-dom"
import { useCookies } from "react-cookie"

const UserMenuMobile = () => {
  const isLoggedIn = useRecoilValue(isLoggedInState)
  const navigate = useNavigate()
  const [cookies] = useCookies(["username"])

  return (
    <UserMenuDiv>
      {isLoggedIn ? (
        <UserProfileButton onClick={() => navigate("/user/mypage")}>
          <BsPersonCircle />
          {cookies.username}
        </UserProfileButton>
      ) : (
        <>
          <TextButton fontSize={14} onClick={() => navigate("/user/login")}>
            로그인
          </TextButton>
          <TextButton fontSize={14} onClick={() => navigate("/user/signup")}>
            회원가입
          </TextButton>
        </>
      )}
    </UserMenuDiv>
  )
}

export default UserMenuMobile

const UserMenuDiv = styled.div`
  width: 120px;
  display: flex;
  gap: 5px;
  justify-content: flex-end;
  position: relative;
`

const UserProfileButton = styled(TextButton).attrs(() => ({
  color: "var(--custom-light-blue)",
  fontSize: 16,
}))`
  display: flex;
  align-items: center;

  & > svg {
    height: 20px;
    width: 20px;
    margin-right: 5px;
  }
`
